<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
                <h2 class="tw-text-white tw-text-center tw-pt-2 tw-pb-4 tw-text-lg lg:tw-text-2xl">Demandez votre bilan auditif sur-mesure gratuit<sup>1</sup></h2>
            </div>
            <fieldset class="tw-px-5 tw-pb-3 lg:tw-px-5 lg:tw-pb-12">
                <validation-provider class="tw-w-full tw-w-block" name="firstName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            id="input-firstName"
                            placeholder=" "
                            v-model="firstName"
                        >
                        <label>
                            Prénom
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="lastName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            id="input-lastName"
                            placeholder=" "
                            v-model="lastName"
                        >
                        <label>
                            Nom
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'invalide' }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            id="input-email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:fr" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            id="input-phone"
                            placeholder=" "
                            v-model="phone"
                            v-mask="{mask: '9999999999', placeholder: ' '}"
                        >
                        <label>
                            Télephone
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="zipcode" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-zipcode" :class="classes">
                        <input type="tel"
                            id="input-zipcode"
                            placeholder=" "
                            v-model="zipcode"
                            v-mask="{mask: '99999', placeholder:' '}"
                        >
                        <label>
                            Code Postal
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-white">J'ai lu et j'accepte la <a href="#" @click.prevent="$store.state.modal.terms = true"><u>Politique</u></a> relative aux données personnelles.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: true } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="receiveOffers">
                                <span class="checkmark"></span>
                                <span class="tw-text-white">J’accepte de recevoir des communications et offres par email, téléphone et SMS de la part d’Amplifon.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>

                <span class="tw-text-white tw-block" style="font-size: 11px; line-height: 14px;">
                    Si vous souhaitez ne pas faire l'objet de prospection commerciale par téléphone, nous vous rappelons que vous pouvez également vous inscrire sur la liste d'opposition au démarchage téléphonique BLOCTEL ou en contactant le DPO à l’adresse email : <a
                    href="mailto:dpd.france@amplifon.com" class="tw-underline">dpd.france@amplifon.com</a>
                </span>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta tw-uppercase tw-text-white tw-bg-black tw-w-full tw-text-2xl"
                        id="submit"
                        :disabled="formLoading"
                    >
                        J'en profite
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            firstName: this.$route.query.firstName || '',
            lastName: this.$route.query.lastName || '',
            email: this.$route.query.email || '',
            phone: this.$route.query.phone || '',
            zipcode: this.$route.query.zipcode || '',
            receiveOffers: this.$route.query.receiveOffers || false,
            cible: this.$route.query.cible || '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                email: this.email,
                zipcode: this.zipcode,
                receiveOffers: this.receiveOffers,
                mclic: process.env.VUE_APP_MCLIC,
                cible: this.$route.query.cible,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'déjà enregistré';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
